import { useTranslation } from 'react-i18next';
import { Box, Card, Dropdown, IconButton, Stack, styled, Tag, Text } from 'shell/components';

const QuizCard = ({ quiz, disableOptions, onClick, onClickEdit, onClickDelete }) => {
    const { t } = useTranslation('quiz');

    return (
        <Box sx={{ position: 'relative', width: '100%' }}>
            <Card
                aria-label={quiz.title}
                role={'button'}
                tabIndex={0}
                sx={{ borderRadius: 4, p: 5 }}
                onClick={() => onClick(quiz)}
            >
                <Stack sx={{ width: '100%' }} alignItems={'flex-start'} spacing={2}>
                    <Text variant={'sh2'}>{quiz.title}</Text>
                    <Tag type={'lms'} value={'lms'} label={t('lms-quiz', 'LMS Quiz')} />
                </Stack>
            </Card>
            <CustomBox>
                <Dropdown
                    id={`quiz-${quiz.id}-options`}
                    options={[
                        { key: 'edit', value: t('common:controls.edit', 'Edit'), disabled: disableOptions },
                        { key: 'delete', value: t('common:controls.delete', 'Delete'), disabled: disableOptions },
                    ]}
                    rootComponent={
                        <IconButton
                            aria-label={t('common:controls.more-options', 'More options')}
                            disabled={disableOptions}
                            kind={'moreHorizontal'}
                            size={'medium'}
                            tooltip={{ component: t('common:controls.more-options', 'More options') }}
                            variant={'square'}
                        />
                    }
                    onSelect={({ key }) => {
                        if (disableOptions) return;
                        if (key === 'edit') onClickEdit(quiz);
                        if (key === 'delete') onClickDelete(quiz);
                    }}
                />
            </CustomBox>
        </Box>
    );
};

const CustomBox = styled(Box)(({ theme }) => {
    return {
        position: 'absolute',
        top: theme.spacing(5),
        right: theme.spacing(5),
    };
});

export default QuizCard;
